import { useQuery } from 'react-query';
import { AxiosResponse } from 'axios';
import { getOrderById } from '../../services/order.service';

export const getOrdersByIdQueryKey = 'getOrdersByID';
export const useOrderDetails = (dataPage) => useQuery([getOrdersByIdQueryKey, dataPage.id], () => getOrderById(dataPage)
  .then((result: AxiosResponse<Order.Item>) => result.data), {
  refetchOnWindowFocus: false, retry: false, cacheTime: 0,
}) as AxiosResponse<Order.Item>;
